// extracted by mini-css-extract-plugin
export default {"wrapper":"Privacy_wrapper__JgUGe"};